export default __webpack_public_path__ + "static/media/404-emoji.107b45c4.png";